import styled from "@emotion/styled";
import {IconButton} from "@mui/material";
import {breakpoints} from "assets/theme";

export const CloseButton = styled(IconButton)`
	&& {
		z-index: 1;
		color: #ffffff;
		top: 4px;
		right: 4px;
		position: absolute;
	}
`;

export const Overlay = styled.div`
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
	width: 100%;
	height: 100%;
	z-index: 50;
	left: 0;
	top: 0;

	&.above-player-pool {
		z-index: 1000;
	}
`;

export const Modal = styled.div`
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: calc(100% - 20px);
	max-height: calc(100% - 20px);
	overflow: auto;
	max-width: 600px;
	min-height: 200px;
	border-radius: 5px;
	box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
	z-index: 51;
	background: #545456;
	color: ${({theme}) => theme.colorPalette.primary};

	&.big-icon .modal-inner {
		padding-top: 34px;
	}

	&.p-0 .modal-inner {
		padding: 0;
	}

	&.above-player-pool {
		z-index: 1001;
	}

	&.white {
		background: #fff;
	}
`;

export const ModalInner = styled.div`
	position: relative;
	padding: 64px 20px 40px;

	@media (min-width: ${breakpoints.medium}) {
		padding: 64px 20px 40px;
	}
`;

export const ModalContent = styled.div`
	text-align: center;
`;

export const ModalTitle = styled.h4`
	font-size: 20px;
	line-height: 20px;
	letter-spacing: 0.2px;
	margin-bottom: 20px;
	font-family: ${({theme}) => theme.baseFont};
	color: ${({theme}) => theme.colorPalette.white};
	font-weight: 700;
`;

export const ModalText = styled.p`
	font-size: 16px;
	font-family: ${({theme}) => theme.secondFont};
	color: ${({theme}) => theme.colorPalette.white};
	line-height: 24px;
	margin-bottom: 20px;
`;

export const ModalIcon = styled.img`
	width: 80px;
	height: auto;
	margin-bottom: 20px;

	&.small {
		width: 50px;
	}
`;

export const ButtonsBox = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	gap: 20px;

	button,
	a {
		display: block;
		width: 100%;
		align-self: stretch;
		color: #202020;
		border-radius: 4px;
		text-align: center;
	}

	@media (min-width: ${breakpoints.mobile}) {
		flex-direction: row;

		button,
		a {
			max-width: 300px;
		}
	}
`;
